"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var HeadsetFilter = /** @class */ (function () {
    function HeadsetFilter() {
        this.syncEmployees = true;
        this.syncInventory = true;
        this.syncCustomers = true;
        this.syncPayments = true;
        this.syncPurchaseOrders = true;
        this.selectedLocationIds = [];
    }
    HeadsetFilter.prototype.setSyncEmployees = function (value) {
        this.syncEmployees = value;
    };
    HeadsetFilter.prototype.setSyncInventory = function (value) {
        this.syncInventory = value;
    };
    HeadsetFilter.prototype.setSyncCustomers = function (value) {
        this.syncCustomers = value;
    };
    HeadsetFilter.prototype.setSyncPayments = function (value) {
        this.syncPayments = value;
    };
    HeadsetFilter.prototype.setSyncPurchaseOrders = function (value) {
        this.syncPurchaseOrders = value;
    };
    HeadsetFilter.prototype.setSelectedLocationIds = function (locationIds) {
        this.selectedLocationIds = locationIds;
    };
    __decorate([
        mobx_1.observable
    ], HeadsetFilter.prototype, "syncEmployees", void 0);
    __decorate([
        mobx_1.observable
    ], HeadsetFilter.prototype, "syncInventory", void 0);
    __decorate([
        mobx_1.observable
    ], HeadsetFilter.prototype, "syncCustomers", void 0);
    __decorate([
        mobx_1.observable
    ], HeadsetFilter.prototype, "syncPayments", void 0);
    __decorate([
        mobx_1.observable
    ], HeadsetFilter.prototype, "syncPurchaseOrders", void 0);
    __decorate([
        mobx_1.observable
    ], HeadsetFilter.prototype, "selectedLocationIds", void 0);
    __decorate([
        mobx_1.action
    ], HeadsetFilter.prototype, "setSyncEmployees", null);
    __decorate([
        mobx_1.action
    ], HeadsetFilter.prototype, "setSyncInventory", null);
    __decorate([
        mobx_1.action
    ], HeadsetFilter.prototype, "setSyncCustomers", null);
    __decorate([
        mobx_1.action
    ], HeadsetFilter.prototype, "setSyncPayments", null);
    __decorate([
        mobx_1.action
    ], HeadsetFilter.prototype, "setSyncPurchaseOrders", null);
    __decorate([
        mobx_1.action
    ], HeadsetFilter.prototype, "setSelectedLocationIds", null);
    return HeadsetFilter;
}());
exports.HeadsetFilter = HeadsetFilter;
//# sourceMappingURL=Headset.js.map